import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 40.01 40.01",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: /* @__PURE__ */ _jsx("path", { d: "M27.4,27.4a2.41,2.41,0,0,1,1.77-.73H40V2.5A2.41,2.41,0,0,0,39.28.73,2.41,2.41,0,0,0,37.51,0H2.5A2.41,2.41,0,0,0,.73.73,2.41,2.41,0,0,0,0,2.5v35a2.41,2.41,0,0,0,.73,1.77A2.41,2.41,0,0,0,2.5,40H26.67V29.17A2.41,2.41,0,0,1,27.4,27.4ZM30,39.93a6.33,6.33,0,0,0,3.44-1.69l4.79-4.79A6.33,6.33,0,0,0,39.93,30H30Z" })
		})
	})
});
export default SvgNoteIcon;
